import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'

function OtpInput({ length = 6, value, onChange, disabled }) {
  const refs = useRef([])
  const chars = Array.from({ length }, (_, i) => value[i] || '')

  useEffect(() => {
    refs.current[0]?.focus()
  }, [])

  const setAt = (index, digit) => {
    const next = chars.slice()
    next[index] = digit
    onChange(next.join('').slice(0, length))
  }

  const handleChange = (index, raw) => {
    const cleaned = raw.replace(/\D/g, '')
    if (!cleaned) {
      setAt(index, '')
      return
    }
    if (cleaned.length > 1) {
      const next = chars.slice()
      cleaned.split('').forEach((d, i) => {
        if (index + i < length) next[index + i] = d
      })
      onChange(next.join('').slice(0, length))
      refs.current[Math.min(index + cleaned.length, length - 1)]?.focus()
      return
    }
    setAt(index, cleaned)
    if (index < length - 1) refs.current[index + 1]?.focus()
  }

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !chars[index] && index > 0) {
      refs.current[index - 1]?.focus()
      setAt(index - 1, '')
    }
  }

  return (
    <div className="flex justify-between gap-2">
      {chars.map((char, index) => (
        <input
          key={index}
          ref={(el) => {
            refs.current[index] = el
          }}
          inputMode="numeric"
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
          maxLength={1}
          disabled={disabled}
          value={char}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          className={cn(
            'h-14 w-12 rounded-2xl border border-line bg-elevated text-center text-3xl font-bold text-ink outline-none focus:border-theme focus:shadow-glow sm:h-16 sm:w-14',
            disabled && 'opacity-60'
          )}
        />
      ))}
    </div>
  )
}

OtpInput.propTypes = {
  length: PropTypes.number,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

export default OtpInput
